<template>
  <v-overlay v-model="exibir" class="d-flex align-center justify-center text-center" persistent>
    <v-card class="pa-2" max-width="350">
      <v-icon icon="mdi-cellphone-screenshot" size="50" class="mb-4" />
      <v-card-title class="text-h5">Tela Cheia</v-card-title>
      <v-card-text>
        Para uma melhor visualização e utilização da alicação sugerimos o uso em
        <strong>Tela Cheia</strong></v-card-text
      >
      <v-card-actions class="d-flex justify-space-between">
        <v-btn color="primary" variant="text" size="large" @click="onClickRecusar()"> Recusar </v-btn>
        <v-btn color="primary" variant="flat" size="large" @click="onClickAceitar()"> Aceitar </v-btn>
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script setup lang="ts">
// Vue
import { ref, onMounted } from 'vue';

// Vuetify
import { usePWADisplayMode } from '../pwa/usePWADisplayMode';

// Stores
import { useLayoutStore } from '@/stores/LayoutStore';

// Shared
import WindowUtils from '@/shared/utils/WindowUtils';
import BrowserUtils from '@/shared/utils/BrowserUtils';

const { isStandalone } = usePWADisplayMode();
const layoutStore = useLayoutStore();

// Reativas
const exibir = ref<boolean>(false);

onMounted(() => {
  setTimeout(async () => {
    layoutStore.configScreen.suportaMudancaOrientacao = await WindowUtils.aceitaMudarOrientacao();

    // Se for nativo não sugere a tela cheia
    if (isStandalone.value) return;

    // Se não for navegador mobile não sugere a tela cheia
    if (!BrowserUtils.isMobile()) return;

    exibir.value = true;
  }, 1000);
});

async function onClickAceitar() {
  try {
    await document.documentElement.requestFullscreen();
    layoutStore.configScreen.fullscreen = true;
  } catch (error) {
    console.warn(error);
  } finally {
    exibir.value = false;
  }
}

function onClickRecusar() {
  exibir.value = false;
}
</script>
